<template>
  <div id="team_by_number_of_starters" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div v-if="possession_type_dropdown" class="col-md-2">
        <label class="typo__label">{{possession_type_dropdown.label}}</label>
        <multiselect
          v-model="possession_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="possession_type_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div v-if="time_type_dropdown" class="col-md-2">
        <label class="typo__label">{{time_type_dropdown.label}}</label>
        <multiselect
          v-model="time_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="time_type_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="possession_start_dropdown">
        <possession-start-select v-model="possession_start_selected" :options="possession_start_dropdown"></possession-start-select>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Graph</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="results" class="chart_title">
        <h2>Team Possession Length Density Plots</h2>
        <p>Possession length in seconds, league average in red</p>
    </div>
    <div class="row margin-padding">
      <div class="col-md-11" id="chart_container"></div>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import PossessionStartSelect from './mixins/PossessionStartSelect.vue'
import { season, seasonType, startType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'TeamPossessionLength',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    PossessionStartSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, GetDropdownOptions, PossessionStartSelect, season, seasonType, startType],
  data () {
    return {
      loading: false,
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_dropdown: {},
      seasons_selected: [],
      season_selected_string: '',
      possession_type_selected: undefined,
      possession_type_dropdown: undefined,
      time_type_selected: undefined,
      time_type_dropdown: undefined,
      possession_start_dropdown: undefined,
      possession_start_selected: undefined,
      show_error_message: false,
      results: undefined,
      api_endpoint: 'get-possession-length-frequency/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg').remove()
      this.results = []
      this.seasons_selected = []
      this.season_selected_string = ''
      this.$router.push({name: 'team_possession_length', params: {league: this.$parent.league}})
    },
    setPossessionTypeDropdown () {
      this.possession_type_dropdown = {
        'label': 'Possession Type',
        'data': [
          {'id': 'Offense', 'text': 'Offense'},
          {'id': 'Defense', 'text': 'Defense'}
        ]
      }
      if (!this.possession_type_selected) {
        this.possession_type_selected = this.possession_type_dropdown.data[0]
      }

      if (this.$route.query.PossessionType) {
        this.possession_type_dropdown.data.forEach((possessionType) => {
          if (possessionType.id === this.$route.query.PossessionType) {
            this.possession_type_selected = possessionType
          }
        })
      }
    },
    setTimeTypeDropdown () {
      this.time_type_dropdown = {
        'label': 'Time Type',
        'data': [
          {'id': 'IncludeSecondChances', 'text': 'Include Second Chance Time'},
          {'id': 'ExcludeSecondChances', 'text': 'Exclude Second Chance Time'}
        ]
      }
      if (!this.time_type_selected) {
        this.time_type_selected = this.time_type_dropdown.data[0]
      }

      if (this.$route.query.TimeType) {
        this.time_type_dropdown.data.forEach((timeType) => {
          if (timeType.id === this.$route.query.TimeType) {
            this.time_type_selected = timeType
          }
        })
      }
    },
    setPossessionStartDropdown () {
      this.possession_start_dropdown = this.start_type_dropdown_options
      this.setPossessionStartType()
      if (!this.possession_start_selected) {
        this.possession_start_selected = this.possession_start_dropdown.data[0]
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.possession_type_selected && this.time_type_selected) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setPossessionTypeDropdown, this.setTimeTypeDropdown, this.setPossessionStartDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.PossessionType && this.$route.query.TimeType) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$possessionTypeParam] = this.possession_type_selected.id
      params[this.$timeTypeParam] = this.time_type_selected.id
      params[this.$startTypeParam] = this.possession_start_selected.id

      this.$router.push({name: 'team_possession_length', query: params})
    },
    getStats () {
      this.show_error_message = false
      var params = this.$route.query
      d3.selectAll('svg').remove()
      if (params.Season && params.SeasonType && params.PossessionType && params.TimeType) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.results
              var teams = Object.keys(this.results)
              this.league_totals = this.expandDataForChart(response.data.league_totals)
              teams.forEach((team) => {
                this.addChart(this.results[team], team, this.league_totals)
              })
              this.loading = false
            } else {
              this.show_error_message = true
              this.results = undefined
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.results = undefined
            this.error = error
          })
      }
    },
    addChart (teamData, title, leagueData) {
      var margin = {top: 10, right: 20, bottom: 30, left: 20}
      var width = 250 - margin.left - margin.right
      var height = 250 - margin.top - margin.bottom

      var svg = d3.select('#chart_container')
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var x = d3.scaleLinear()
        .domain([0, 40])
        .range([margin.left, width - margin.right])

      var y = d3.scaleLinear()
        .domain([0, 0.1])
        .range([height - margin.bottom, margin.top])

      g.append('g')
        .attr('class', 'axis axis--x')
        .attr('transform', 'translate(0,' + (height - margin.bottom) + ')')
        .call(d3.axisBottom(x))

      g.append('g')
        .attr('class', 'axis axis--y')
        .attr('transform', 'translate(' + margin.left + ',0)')
        .call(d3.axisLeft(y).ticks(null, '%'))

      var chartData = this.expandDataForChart(teamData)

      var density = this.kernelDensityEstimator(this.kernelEpanechnikov(3), x.ticks(40))(chartData)
      var leagueDensity = this.kernelDensityEstimator(this.kernelEpanechnikov(3), x.ticks(40))(leagueData)

      g.append('path')
        .datum(density)
        .attr('class', 'team-possession-density')
        .attr('d', d3.line()
          .curve(d3.curveBasis)
          .x(function (d) { return x(d[0]) })
          .y(function (d) { return y(d[1]) }))

      g.append('path')
        .datum(leagueDensity)
        .attr('class', 'league-possession-density')
        .attr('d', d3.line()
          .curve(d3.curveBasis)
          .x(function (d) { return x(d[0]) })
          .y(function (d) { return y(d[1]) }))

      g.append('text')
        .attr('class', 'title')
        .attr('x', width / 2)
        .attr('y', 0)
        .attr('text-anchor', 'middle')
        .text(title)
    },
    kernelDensityEstimator (kernel, X) {
      return function (V) {
        return X.map(function (x) {
          return [x, d3.mean(V, function (v) { return kernel(x - v) })]
        })
      }
    },
    kernelEpanechnikov (k) {
      return function (v) {
        return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0
      }
    },
    expandDataForChart (data) {
      var allCounts = []
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].count; j++) {
          allCounts.push(data[i].length)
        }
      }
      return allCounts
    }
  }
}
</script>

<style>

.axis {
  font: 10px sans-serif;
}

.axis path,
.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
  stroke-width: .5;
}

.team-possession-density {
  fill: none;
  stroke: #000;
  stroke-linejoin: round;
  stroke-width: 1.5;
}

.league-possession-density {
  fill: none;
  stroke:red;
  stroke-linejoin: round;
  stroke-width: 1.5;
}

.x.axis path {
  display: none;
}

div.chart_title {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TeamPossessionLength.vue